import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {select_user_VM} from 'redux/auth/selectors'
import {tabNames, TabType} from 'router/settings'

import {Avatar, Breadcrumb, Container, Icon, Tooltip} from '@mdsol/onex-design'
import {Navbar as BSNavbar} from 'react-bootstrap'

import './navbar.scss'

interface NavbarProps {
  routerRefs: any,
  activeTab: TabType,
  tabName?: string,
}

const Navbar: FC<NavbarProps> = ({routerRefs, activeTab}) => {
  const {name, initials, role, isAdmin} = useSelector(select_user_VM)
  const activeBreadcrumb = tabNames[activeTab]

  return (
    <BSNavbar id='navbar' fixed='top'>
      <Container fluid className='left'>
        <BSNavbar.Brand>
          <Breadcrumb>
            <Breadcrumb.Item {...routerRefs[TabType.home]}><Icon>home</Icon></Breadcrumb.Item>
            <Breadcrumb.Item {...routerRefs[activeTab]} active>{activeBreadcrumb}</Breadcrumb.Item>
          </Breadcrumb>
        </BSNavbar.Brand>
      </Container>

      <Container fluid className='right'>
        <Tooltip
          dataTestId='tooltip-user-avatar'
          id='tooltip-avatar'
          placement='left-start'
          tooltipChildren={`Welcome, ${name}${role}.`}
        >
          <Avatar dataTestId='user-avatar' size='sm' name={initials} />
          {isAdmin && <Icon className='admin-avatar'>admin_panel_settings</Icon>}
        </Tooltip>
      </Container>
    </BSNavbar>
  )
}

export default Navbar
